class CartDrawerRecommendations extends HTMLElement {
  connectedCallback() {
    this.swiperElement = this.querySelector(
      "[data-swiper-cart-recommendations]"
    );
    if (!this.swiperElement) return;

    this.currentProductId = null;

    this.swiperOptions = {};
    try {
      this.swiperOptions = JSON.parse(this.dataset.options);
    } catch (e) {
      console.error(e);
    }
    console.log("swiperOptions", this.swiperOptions);

    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

    // Initialize on load
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      this.init();
    }

    // Listen for cart updates
    document.addEventListener("cart-drawer:updated", () => {
      this.init();
    });
  }

  async init() {
    const productId = await this.getTargetProductId();

    // Only fetch if product has changed
    if (!productId || productId === this.currentProductId) return;

    this.currentProductId = productId;
    const url = this.buildUrl(productId);

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const source = tempDiv.querySelector("[data-recommended-products]");
        const target = this.querySelector("[data-recommended-products]");

        if (source && source.innerHTML.trim()) {
          target.innerHTML = source.innerHTML;
          this.swiperInstance.update();
        }
      })
      .catch((e) => console.error(e));
  }

  async getTargetProductId() {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      if (!cart.items || !cart.items.length) return null;

      const targetProduct = this.getTargetProduct(cart.items);
      return targetProduct?.product_id || null;
    } catch (e) {
      return null;
    }
  }

  buildUrl(productId) {
    return `${window.Shopify.routes.root}recommendations/products?section_id=${this.dataset.sectionId}&product_id=${productId}&limit=8&intent=related`;
  }

  getTargetProduct(items) {
    const type = this.dataset.recommendationType;

    if (type === "cheapest")
      return items.reduce((min, i) => (i.price < min.price ? i : min));
    if (type === "expensive")
      return items.reduce((max, i) => (i.price > max.price ? i : max));
    if (type === "last") return items[items.length - 1];
    return items[0]; // first
  }
}

customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);
